<template>
    <div class="dynamic-content">
        <h1 class="page-title">Service Fees Overview</h1>

        <p class="desc-text">XigFor charges service fees only for optional platform services.</p>
        <p class="desc-text">All applicable fees are clearly disclosed before use.</p>
        <p class="desc-text">No fees apply to user-to-user transactions unless explicitly stated.</p>
        <p class="desc-text section-spacing">XigFor does not charge commissions on item sales.</p>

        <div class="content-section">
            <h2 class="section-title">Optional Platform Services</h2>
            <p class="desc-text">Some optional platform services may require a service fee.</p>
            <p class="desc-text">These services are not required to use the core marketplace features.</p>
        </div>

        <div class="content-section">
            <h2 class="section-title">Fee Transparency</h2>
            <p class="desc-text">All service fees are displayed clearly before confirmation.</p>
            <p class="desc-text">Users are not charged without explicit acknowledgment.</p>
        </div>

        <div class="content-section">
            <h2 class="section-title">What Fees Are Not</h2>
            <ul class="bullet-list">
                <li>• Not a financial service fee</li>
                <li>• Not an investment-related charge</li>
                <li>• Not a commission on user earnings</li>
            </ul>
        </div>

        <div class="bottom-links">
            <div class="link-item">
                <router-link to="/content/growth-program" class="action-link">Growth Program Overview</router-link>
                <span class="arrow-icon">></span>
            </div>
            <div class="link-item">
                <router-link to="/content/smartrewards-terms" class="action-link">SmartRewards Rules & Terms</router-link>
                <span class="arrow-icon">></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ServiceFees'
}
</script>

<style scoped>
@import './shared-info-styles.css';
</style>
